import { render, staticRenderFns } from "./MqcdList.vue?vue&type=template&id=19815866&scoped=true&"
import script from "./MqcdList.vue?vue&type=script&lang=js&"
export * from "./MqcdList.vue?vue&type=script&lang=js&"
import style0 from "./MqcdList.vue?vue&type=style&index=0&id=19815866&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19815866",
  null
  
)

export default component.exports